import React from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CommonPieChart from "../pie-chart";
import BudgetInsights from "../right-sde-wrapper/BudgetInsights";
import CurrencySelectBox from "../right-sde-wrapper/CurrencySelectBox";
import IncomeDetailsCardInner from "./IncomeDetailsCardInner";

const IncomeDetails = () => {
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  return (
    <>
      <div className="row mx-0 statics-details-row">
        {dashboardData?.totalIncome !== 0 && (
          <div className="total-all-budgets-div position-relative">
            <div className="row mx-0">
              <div className="col-12">
                <CurrencySelectBox />
                <div className="summary-graph">
                  <CommonPieChart type="income" />
                </div>
                <div className="line-tag" />
                <BudgetInsights />
              </div>
            </div>
          </div>
        )}
        <div
          className={`total-all-sources ${
            dashboardData?.totalIncome === 0 ? "w-100" : ""
          }`}
        >
          <div className="row">
            <IncomeDetailsCardInner />
          </div>
        </div>
      </div>
      {dashboardData?.totalIncome == 0 && (
        <div className="col-12 no-data-screen-db">
          <p>
            <Trans
              i18nKey="dashboard.noDataFound"
              components={{
                linkClick: (
                  <Link to={"/settings/edit-form/income"}>
                    <b></b>
                  </Link>
                ),
              }}
            />
          </p>
        </div>
      )}
    </>
  );
};

export default IncomeDetails;
